
import { addDays } from 'date-fns';
import { formatDateDisplay, numberWithCommas, shortFormNumber, wrapLabel } from '../../../utilities/customFunctions'
import ReportCard from './reportCard';
import Skeleton from '../../../../helpers/Skeleton';
import classnames from "classnames"
import { isEmpty } from 'lodash';

export const chartColour = {
    main: "#f9d7f0", base: "#f2f2f2",
    light: "#ffffff",
    dark: "#000000",
    neutral: "#cccccc",
    highlight: "#2496fa",
    accent1: "#8cca8b",
    accent2: "#e06e5e",
    accent3: "#fec663",
    accent4: "#1272a4",
    gridLine: "#eee",
    axis: "#ccc",
    text: "#000000",
    textLight: "#fff",
    subtext: "#666",
    annotation: "#fff"
};
export const baseOption = {
    textStyle: {
        fontFamily: 'Ubuntu, sans-serif'
    },
    legend: { bottom: 0, textStyle: { color: chartColour.subtext } },
    grid: { left: 40, right: 20, top: 70, bottom: 30, containLabel: true },
    tooltip: { trigger: 'axis', axisPointer: { type: "cross" }, },
    toolbox: {
        showTitle: false,
        feature: {
            saveAsImage: { type: ['png'] },
            title: 'Save As Image'
        },
        tooltip: {  show: true,
            backgroundColor: '#000',
             formatter: function (param) {
                return '<div>' + param.title + '</div>'; // user-defined DOM structure
            },
            textStyle: {
                fontSize: 12, 
                color: '#fff'
            },
            extraCssText: 'box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);' }
    },
}

const baseTooltip = {
    backgroundColor: chartColour.light,
    borderColor: chartColour.neutral,
    borderWidth: 1,
    textStyle: { color: chartColour.dark },
    extraCssText: 'text-align: left'
};

const OrderAxis = (data, seriesName, position = "left", prefix = "", numdivlines = "", dashed = true, maxValue = null, suffix = "",) => ({
    yAxis: {
        name: seriesName,
        position,
        max: maxValue,
        axisLabel: { formatter: value => `${prefix}${value}${suffix}` },
        splitLine: { lineStyle: { type: dashed ? "dashed" : "solid" } }
    },
    series: {
        name: seriesName,
        type: "line",
        data,
        lineStyle: { width: 3 }
    }
});
export const createAbsoluteDataSetConversionReport = (categories, roas, conversion) => {
    return {
        title: {
            text: "Daily ROAS and Conversion Rate",
            subtext: "For the selected time range",
            left: "center",
            top: 10,
            textStyle: { fontSize: 14 }
        },
        tooltip: {
            trigger: "axis",
            formatter: (params) => {
                return params
                    .map(
                        (p) =>
                            `${p.seriesName} in ${p.axisValue} : <b>${p.value}${p.seriesName === "Conversion rate" ? "%" : ""
                            }</b>`
                    )
                    .join("<br/>");
            }
        },
        legend: {
            bottom: 0,
            left: "center"
        },
        grid: { top: 75, left: 50, right: 60, bottom: 30, containLabel: true },
        xAxis: {
            type: "category",
            data: categories.map(cat => cat.label),
            axisLabel: { rotate: 45 }
        },
        yAxis: [
            {
                type: "value",
                name: "ROAS",
                position: "left"
            },
            {
                type: "value",
                name: "Conversion rate",
                position: "right",
                axisLabel: { formatter: "{value}%" }
            }
        ],
        series: [
            {
                name: "ROAS",
                type: "line",
                data: roas,
                yAxisIndex: 0,
                smooth: true
            },
            {
                name: "Conversion rate",
                type: "line",
                data: conversion,
                yAxisIndex: 1,
                smooth: true
            }
        ],
        color: ["#1272A4", "#E06E5E"],
        toolbox: {
            feature: {
                saveAsImage: { title: "Save" }
            }
        }
    };
};


export const createAbsoluteDataSetDOOH = (categories, impression, adPlayed, audience) => {
    //console.log(categories)
    const legend = ["Impressions", "Ad played", "Audience average"]

    return ({
        ...baseOption,
        backgroundColor: "#fff",
        title: {
            text: "Total Numbers",
            subtext: "For the selected time range",
            left: "center",
            top: 8,
            textStyle: { color: "#333", fontSize: 16 },
            subtextStyle: { color: "#666", fontSize: 12 },
        },
        tooltip: { trigger: "axis" , extraCssText: 'text-align: left'},
        /* legend: {
            data: legend,
            bottom: 0,
            left: "center",
            textStyle: { color: "#666" },
            itemGap: 20,
        }, */
        grid: {
            left: "10%",
            right: "7.5%",
            bottom: "10%",
            top: "30%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: categories.map(c => c.label || c), // dynamic categories,
            axisLine: { lineStyle: { color: "#000" } },
            axisTick: { alignWithLabel: true }, 
            axisLabel: {
                rotate: 90,
                margin: 12,
                hideOverlap: true,
                interval: "auto",
                //formatter: (v) => v.slice(3), // show '01'...'31'
            },
        },
        dataZoom: [
            { type: "inside", xAxisIndex: 0 },
            //{ type: "slider", xAxisIndex: 0, height: 12, bottom: 6 },
        ],
        yAxis: [
            {
                type: "value",
                name: legend[0],
                position: "left",
                offset: 55,
                axisLabel: { color: "#a6a6a6", formatter: function (value) { return shortFormNumber(value);  }},
                splitLine: { show: false },
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },          
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#1272a4', 
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                }     
            },
            {
                type: "value",
                name: legend[1],
                position: "left",
                axisLabel: { color: "#a6a6a6", formatter: function (value) { return shortFormNumber(value);  }},
                splitLine: { show: true, lineStyle: { type: "dashed", color: "#eee" } },
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#91CC75', 
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                } 
            },
            {
                type: "value",
                name: legend[2],
                position: "right",
                axisLabel: { color: "#a6a6a6", formatter: function (value) { return shortFormNumber(value); } },
                splitLine: { show: false },
                nameLocation: "middle",
                nameRotate: -90,
                nameGap: 25,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#EE6666',
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                }
            },
        ],
        series: [
            {
                name: legend[0],
                type: "line",
                yAxisIndex: 0,
                smooth: false,
                //symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#1272a4" },
                itemStyle: { color: "#1272a4" },
                data: impression?.map(e => +e.value || +e),
            },
            {
                name: legend[1],
                type: "line",
                yAxisIndex: 1,
                smooth: false,
                //symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#91CC75" },
                itemStyle: { color: "#91CC75" },
                data: adPlayed?.map(e => +e.value || +e),
            },
            {
                name: legend[2],
                type: "line",
                yAxisIndex: 2,
                smooth: false,
                //symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#EE6666" },
                itemStyle: { color: "#EE6666" },
                data: audience?.map(e => +e.value || +e),
            },
        ],
    }
    )
}
export const createAbsoluteDataSet = (categories, impression, dailyViewableImp, dailyEngagement, dailyClicks) => {
    const legend = ['Impressions', 'Viewable Impressions', 'Engagements', 'Clicks']
    return ({
        ...baseOption,
        backgroundColor: "#fff",
        title: {
            text: "Total Numbers",
            subtext: "For the selected time range",
            left: "center",
            top: 8,
            textStyle: { color: "#333", fontSize: 16 },
            subtextStyle: { color: "#666", fontSize: 12 },
        },
        tooltip: { trigger: "axis", extraCssText: 'text-align: left' },
        /* legend: {
            data: legend,
            top: 64,
            left: "center",
            textStyle: { color: "#666" },
            itemGap: 20,
        }, */
        grid: {
            left: "7.5%",
            right: "7.5%",
            bottom: "11%",
            top: "30%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: categories.map(c => c.label || c), // dynamic categories,
            axisLine: { lineStyle: { color: "#000" } },
            axisTick: { alignWithLabel: true },
            axisLabel: {
                rotate: 90,
                margin: 12,
                hideOverlap: true,
                interval: "auto",
                //formatter: (v) => v.slice(3), // show '01'...'31'
            },
        },
        dataZoom: [
            { type: "inside", xAxisIndex: 0 },
            //{ type: "slider", xAxisIndex: 0, height: 12, bottom: 6 },
        ],
        yAxis: [
            {
                type: "value",
                name: legend[0],
                position: "left",
                offset: 55,
                axisLabel: { color: "#a6a6a6", formatter: function (value) { return shortFormNumber(value);  }},
                splitLine: { show: false },
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#1272a4', 
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                }   
            },
            {
                type: "value",
                name: legend[1],
                position: "left",
                axisLabel: { color: "#a6a6a6",formatter: function (value) { return shortFormNumber(value);  }},
                splitLine: { show: true, lineStyle: { type: "dashed", color: "#eee" } },
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#91CC75', 
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                } 
            },
            {
                type: "value",
                name: legend[2],
                position: "right",
                axisLabel: { color: "#a6a6a6",formatter: function (value) { return shortFormNumber(value);  }},
                splitLine: { show: false },
                nameLocation: "middle",
                nameRotate: -90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#FAC858',
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                }
            },
            {
                type: "value",
                name: legend[3],
                position: "right",
                offset: 55,
                axisLabel: { color: "#a6a6a6",formatter: function (value) { return shortFormNumber(value);  }},
                splitLine: { show: false },
                nameLocation: "middle",
                nameRotate: -90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#EE6666',
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                }
            },
        ],
        series: [
            {
                name: legend[0],
                type: "line",
                yAxisIndex: 0,
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#1272a4" },
                itemStyle: { color: "#1272a4" },
                data: impression?.map(e => +e.value || +e),
            },
            {
                name: legend[1],
                type: "line",
                yAxisIndex: 1,
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#91CC75" },
                itemStyle: { color: "#91CC75" },
                data: dailyViewableImp?.map(e => +e.value || +e),
            },
            {
                name: legend[2],
                type: "line",
                yAxisIndex: 2,
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#FAC858" },
                itemStyle: { color: "#FAC858" },
                data: dailyEngagement?.map(e => +e.value || +e),
            },
            {
                name: legend[3],
                type: "line",
                yAxisIndex: 3,
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#EE6666" },
                itemStyle: { color: "#EE6666" },
                data: dailyClicks?.map(e => +e.value || +e),
            },
        ],
    }
    )
}
export const createPercentageDataSet = (categories, dailyViewableRate, dailyEngagementRate, dailyCtr) => {

    const legend = ['Viewability %', 'Engagement Rate %', 'CTR %']
    return ({
        ...baseOption,
        backgroundColor: "#fff",
        title: {
            text: "Percentages",
            subtext: "For the selected time range",
            left: "center",
            top: 8,
            textStyle: { color: "#333", fontSize: 16 },
            subtextStyle: { color: "#666", fontSize: 12 },
        },
        tooltip: { trigger: "axis", extraCssText: 'text-align: left' },
        /* legend: {
            data: legend,
            top: 64,
            left: "center",
            textStyle: { color: "#666" },
            itemGap: 20,
        }, */
        grid: {
            left: "7.5%",
            right: "7.5%",
            bottom: "11%",
            top: "30%",
            containLabel: true,
        },
        xAxis: {
            type: "category",
            data: categories.map(c => c.label || c), // dynamic categories,
            axisLine: { lineStyle: { color: "#000" } },
            axisTick: { alignWithLabel: true },
            axisLabel: {
                rotate: 90,
                margin: 12,
                hideOverlap: true,
                interval: "auto",
               // formatter: (v) => v.slice(3),
            },
        },
        dataZoom: [
            { type: "inside", xAxisIndex: 0 },
            //{ type: "slider", xAxisIndex: 0, height: 12, bottom: 6 },
        ],
        yAxis: [
            {
                type: "value",
                name: legend[0],
                position: "left",
                offset: 55,
                axisLabel: { color: "#a6a6a6", formatter: '{value}%' },
                splitLine: { show: false },
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#91CC75', 
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                } 
            },
            {
                type: "value",
                name: legend[1],
                position: "left",
                axisLabel: { color: "#a6a6a6", formatter: '{value}%' },
                splitLine: { show: true, lineStyle: { type: "dashed", color: "#eee" } },
                nameLocation: "middle",
                nameRotate: 90,
                nameGap: 40,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#EE6666', 
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                } 
            },
            {
                type: "value",
                name: legend[2],
                position: "right",
                axisLabel: { color: "#a6a6a6", formatter: '{value}%' },
                splitLine: { show: false },
                nameLocation: "middle",
                nameRotate: -90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },
                axisLine: {
                    show: true,
                    lineStyle: {
                        color: '#FAC858', 
                        width: 1,
                        type: 'solid'
                    }
                },
                axisTick: {
                    show: true, lineStyle: {
                        type: 'dashed'                        
                    }
                } 
            },
        ],
        series: [
            {
                name: legend[0],
                type: "line",
                yAxisIndex: 0,
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#91CC75" },
                itemStyle: { color: "#91CC75" },
                data: dailyViewableRate?.map(e => +e.value || +e),
            },
            {
                name: legend[1],
                type: "line",
                yAxisIndex: 1,
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#EE6666" },
                itemStyle: { color: "#EE6666" },
                data: dailyEngagementRate?.map(e => +e.value || +e),
            },
            {
                name: legend[2],
                type: "line",
                yAxisIndex: 2,
                smooth: false,
                symbol: "circle",
                symbolSize: 6,
                lineStyle: { width: 2, color: "#FAC858" },
                itemStyle: { color: "#FAC858" },
                data: dailyCtr?.map(e => +e.value || +e),
            },
        ],
    }
    )
}


export const createAbsoluteDataSetAttention = (categories, impression, scores, perMinute = true) => {

    return {
        ...baseOption,
        title: {
            text: "Daily breakdown",
            subtext: "For the selected time range",
            left: "center",
            textStyle: { color: chartColour.dark },
            subtextStyle: { color: chartColour.subtext }
        },
        tooltip: {
            trigger: "axis",
            formatter: params => {
                let label = params[0].axisValue;
                return params
                    .map(p => `${p.seriesName} in ${label} : <b>${p.value}</b>`)
                    .join("<br/>");
            },
            extraCssText: 'text-align: left'
        },
        legend: {
            data: ["Impressions", perMinute ? "Attention Time (APM)" : "Attention Time (Secs)"],
            top: "bottom", left: "center",
            textStyle: { color: chartColour.dark }
        },
        xAxis: {
            type: "category",
            data: categories.map(c => c.label),
            axisLabel: {
                rotate: 45,
                color: chartColour.dark
            },
            axisLine: { lineStyle: { color: chartColour.axis } },
            splitLine: { show: false }
        },
        yAxis: [
            {
                type: "value",
                name: "Impressions",
                position: "left",
                axisLine: { lineStyle: { color: chartColour.axis } },
                axisLabel: { color: chartColour.dark },
                splitLine: { lineStyle: { color: chartColour.gridLine, type: "dashed" } }
            },
            {
                type: "value",
                name: perMinute ? "Attention Time (APM)" : "Attention Time (Secs)",
                position: "right",
                axisLine: { lineStyle: { color: chartColour.axis } },
                axisLabel: { color: chartColour.dark },
                splitLine: { show: false }
            }
        ],
        series: [
            {
                name: "Impressions",
                type: "line",
                yAxisIndex: 0,
                data: impression.map(d => d.value),
                lineStyle: { width: 3, color: chartColour.accent1 },
                itemStyle: { color: chartColour.accent1 }
            },
            {
                name: perMinute ? "Attention Time (APM)" : "Attention Time (Secs)",
                type: "line",
                yAxisIndex: 1,
                data: scores.map(d => d.value),
                lineStyle: { width: 3, color: chartColour.accent2 },
                itemStyle: { color: chartColour.accent2 }
            }
        ],
        backgroundColor: chartColour.light
    };
}

export const getCategoriesDates = (startDate, stopDate) => {
    var dateArray = [];
    var currentDate = startDate;
    while (currentDate <= stopDate) {
        dateArray.push({ label: formatDateDisplay(currentDate) });
        currentDate = addDays(currentDate, 1)
    }
    return dateArray;
}


export const createSpatklineDataset = (dataStructure, caption = "", numberprefix = "", numbersuffix = "") => {
    return ({
        ...baseOption,
        tooltip: {
        trigger: "axis",
            formatter: params => {
                const p = params[0]; 
                return dataStructure ? dataStructure.find(item => item.value === p.data)?.tooltext?.replace("$dataValue", p.data) : ""
        },
        extraCssText: 'text-align: left',
        axisPointer: { type: "line" }
        },
        grid: { left: 0, right: 0, top: 10, bottom: 10 },
        xAxis: {
            type: 'category',
            show: false,
            data: dataStructure.map((_, idx) => idx),
        },
        yAxis: {
            type: 'value',
            show: false
        },
        series: [
            {
                type: 'line',
                data: dataStructure.map(d => d.value),
                smooth: false,
                showSymbol: false,
                lineStyle: { width: 1, color: chartColour.axis },
                emphasis: {
                    focus: 'series',
                    showSymbol: true,
                    itemStyle: {
                        borderColor: '#fff',
                        borderWidth: 2
                    }
                },
                markPoint: {
                    symbol: 'circle',
                    symbolSize: 8,
                    label: {
                        show: false
                    },
                    data: [
                        {
                            type: 'max', name: 'Max',
                            itemStyle: { color: '#a4eb6f', borderColor: '#fff', borderWidth: 2 }
                        },
                        {
                            type: 'min', name: 'Min',
                            itemStyle: { color: '#ff4c4c', borderColor: '#fff', borderWidth: 2 }
                        }
                    ]
                }
            }
        ]
    })

}



export const createBarDataset = (dataStructure, caption = "") => {
    return {
        ...baseOption,
        legend: { show: false },
        title: {
            text: caption,
            subtext: "For the selected time range",
            left: "center",
            top: 10,
            textStyle: {
                color: chartColour.dark,
                fontSize: 14
            }
        },
        grid: {
            top: 70,
            bottom: 20,
            left: 50,
            right: 20
        },
        xAxis: {
            type: "category",
            data: dataStructure.map(d => d.label),
            axisLabel: {
                interval: 0,  // force show all labels
                color: chartColour.subtext
            }
        },
        yAxis: {
            type: "value",
            min: 0,
            max: 100,
            axisLabel: {
                formatter: "{value}%",
                color: chartColour.subtext
            },
            splitLine: {
                show: false
            }
        },
        tooltip: {
            trigger: "axis",
            axisPointer: { type: "shadow" },
            formatter: params => {
                const val = params[0].value;
                return `${params[0].axisValue}: <b>${val}%</b>`;
            },
            extraCssText: 'text-align: left'
        },
        series: [
            {
                name: caption,
                type: "bar",
                barWidth: "50%",
                data: dataStructure.map((d, i) => ({
                    value: d.value,
                    itemStyle: {
                        color: [chartColour.accent4, chartColour.accent1, chartColour.accent2, chartColour.accent3][i]  // 🎨 set per-bar color
                    }
                })),
                label: {
                    show: false
                }
            }
        ],
        backgroundColor: chartColour.light
    };
}

export const create2DBarDataset = (dataStructure = [], caption = "Publisher breakdown") => {
    //this is unused
    return (
        {
            chart: {
                caption: caption,
                theme: "buddy-theme-1",
                //subcaption: "Top 10 publisher breakdown",
                plottooltext:
                    "$label: <b>$dataValue</b>",
                showvalues: "0",
                decimals: "0",
                numbersuffix: "",
                usesameslantangle: "0",
                showpercentvalues: "1",
                labelPadding: "10",
                yAxisMaxValue: 1000,
                exportEnabled: "0",
                exportFormats: "png | jpg | svg | csv| xlsx",
                exportMode: "client",
                exportFileName: "Publisher breakdown"
            },
            data: [
                ...dataStructure
            ]

        }
    )
}


export const createLedDataset = (dataStructure, caption = "") => {
    //this is unused
    return (
        {
            chart: {
                caption: caption,
                theme: "buddy-theme",
                subcaption: "",
                lowerLimit: "0",
                upperLimit: "1000",
                valueAbovePointer: "1",
                lowerLimitDisplay: "0",
                upperLimitDisplay: "1000",
                numberSuffix: "",
                exportEnabled: "1",
                exportFormats: "png | jpg | svg | csv| xlsx",
                exportMode: "client",
                exportFileName: caption,
                gaugeFillMix: "{light}"

            },
            colorRange: {
                "color": [
                    {
                        minValue: "0",
                        maxValue: dataStructure,
                        code: "#A01A7D"
                    },
                    {
                        minValue: dataStructure,
                        maxValue: "1000",
                        code: "#F2F2F2"
                    }
                ]
            },
            pointers: {
                pointer: [
                    {
                        value: dataStructure
                    }
                ]
            }


        }
    )
}



export const createOverlappingDataset = (dataStructure, caption = "", perMinute = true) => {
  return {
    ...baseOption,
    legend: { top: "bottom", left: "center" },
    title: {
      text: caption,
      subtext: "Against benchmark",
      left: "center",
      textStyle: { color: chartColour.dark, fontSize: 14 },
      subtextStyle: { color: chartColour.subtext, fontSize: 12 }
    },
    grid: {
      top: 60,
      bottom: 20,
      left: 40,
      right: 40
    },
    xAxis: {
      type: "value",
      min: 0,
      max: 1000,
      splitLine: { show: false },
      axisLabel: {
        color: chartColour.subtext
      }
    },
    yAxis: {
      type: "category",
      data: [""], // single bar placeholder
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: { show: false }
    },
    tooltip: {
      trigger: "axis",
      axisPointer: { type: "shadow" },
      formatter: params => {
        return params
          .map(p => `<b>${p.seriesName}</b>: ${p.value}`)
          .join("<br/>");
      },
      extraCssText: 'text-align: left'
    },
    series: [
      {
        name: "Benchmark",
        type: "bar",
        data: [385], // fixed benchmark
        barWidth: 30,
        itemStyle: {
          color: chartColour.neutral,
          opacity: 0.6
        },
        z: 1
      },
      {
        name: perMinute ? "Attention Time (APM)" : "Attention Time (Secs)",
        type: "bar",
        data: [dataStructure],
        barWidth: 15,
        itemStyle: {
          color: chartColour.highlight
        },
        z: 2
      }
    ],
    backgroundColor: chartColour.light
  };
};



const addonDataSetLumen = (data, caption, max = 5, isVertical = false, key = "", perMinute = true) => {
    let labels = []
    let dataSeriesImp = []
    let dataSeriesScore = []
    for (let i = 0; i < data.length && i < max; i++) {
        let obj = data[i]
        if (obj && key) {
            labels[i] = { "label": obj[key] }
        }
        dataSeriesImp[i] = { "value": obj.impressions }
        dataSeriesScore[i] = { "value": obj.apm || 0 }
    }
    return createMyltiSeriesDataset(labels, dataSeriesImp, dataSeriesScore, caption, isVertical, perMinute ? "Attention Time (APM)" : "Attention Time (Secs)")
}
export const renderGaugeData = (title, values) => {

    return {
        ...baseOption,
        grid: { left: 40, right: 20, top: 0, bottom: 10, containLabel: true },
        toolbox: {},
        legend: { top: "bottom", left: "center" },
        backgroundColor: chartColour.light,
        title: {
            text: title,
            left: 'center',
            top: "2%",
            textStyle: { color: chartColour.dark, fontSize: 18 }
        },
        tooltip: {
            trigger: 'item',
            formatter: params => {
                const value = params.value || 0;
                const percent = params.data?.percent != null ? params.data?.percent.toFixed(2) : 0;
                if (percent) return `<b>${params.name}</b> was <b>${value}</b>, which was ${percent}% of parent category`
                return `<b>${params.name}</b> was <b>${value}</b>`;
            },
            extraCssText: 'text-align: left'
        },
        series: [
            {
                type: 'sunburst',
                center: ['50%', '53%'], 
                radius: [0, '70%'],
                nodeClick: false,
                sort: null,
                emphasis: {
                    focus: 'none',
                    itemStyle: { opacity: 1 }
                },
                label: {
                    rotate: 0,
                    color: chartColour.dark,
                    fontSize: 12,
                    overflow: 'break',  // breaks text into multiple lines
                    minAngle: 0,        // always show label even in small arcs
                    show: true,
                },
                levels: [
                    {
                        r0: '0%',
                        r: '30%',
                        label: {
                            position: 'center',
                            color: chartColour.dark,
                            fontSize: 14,
                            fontWeight: 'bold',
                            fontFamily:'Ubuntu, sans-serif',
                            formatter: () => 'Scope 3\ncategories'
                        },
                        itemStyle: { borderWidth: 0 }
                    },
                    {
                        r0: '25%',
                        r: '55%',
                        itemStyle: { borderWidth: 1, borderColor: chartColour.light },
                        label: { rotate: 0 }
                    },
                    {
                        r0: '55%',
                        r: '85%',
                        itemStyle: { borderWidth: 1, borderColor: chartColour.light },
                        label: { rotate: 0 }
                    }
                ],
                data: (values || []).filter(d => d.value > 0)
            }
        ],
        graphic: {
            elements: [
                {
                    type: 'text',
                    left: 'center',
                    top: '50%',
                    style: {
                        text: 'Scope 3\ncategories',
                        fontSize: 16,
                        fill: '#000',
                        textAlign: 'center',
                        textVerticalAlign: 'middle',
                        fontFamily:'Ubuntu, sans-serif',
                    }
                }
            ]
        },
    };
}
export const addonDataEmissions = (data, caption = "Publisher breakdown", max = 10, vertical = true) => {
    let labels = []
    let dataSeriesImp = []
    for (let i = 0; i < data?.length && i < max; i++) {
        let obj = data[i]
        if (obj) {
            labels[i] = obj.name
        }
        dataSeriesImp[i] = { "value": obj.total }
    }
    let isVertical = vertical ? { rotate: 45 } : {}

    return ({
        ...baseOption,
        legend: { top: "bottom", left: "center" },
        title: {
            text: caption,
            subtext: "Top 10 publishers",
            left: "center",
        },
        tooltip: {
            ...baseTooltip,
            trigger: "axis",
            axisPointer: { type: "shadow" },
            valueFormatter: value => value.toFixed(4)
        },
        grid: {
            left: '7.5%',
            right: '7.5%',
            bottom: '5%',
            top: "70",
            containLabel: true
        },
        xAxis: {
            type: "category",
            data: labels,
            axisLabel: {
                ...isVertical,
                color: chartColour.dark,
                interval: 0, // show all labels
                formatter: (value) => wrapLabel(value)  },
            axisLine: { lineStyle: { color: chartColour.neutral } },
        },
        yAxis: {
            type: "value",
            name:  `Total CO₂ in t`,
            position: "left",
            offset: 5,
            axisLine: { lineStyle: { color: chartColour.neutral } },
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 45,
            nameTextStyle: { color: "#a6a6a6" },
        },
        series: [
            {
                name: 'Total CO₂ in t',
                type: 'bar', // or 'column' equivalent
                data: dataSeriesImp.map(item => item.value || item), // adapt to your data structure
                itemStyle: {
                    color: '#D8EDF8'
                },
            }
        ],


    })

}
const addonDataSetAmplified = (data, caption, max = 5, key = "", subcaption = "") => {
    let labels = []
    let dataSeriesImp = []
    let dataSeriesActive = []
    for (let i = 0; i < data.length && i < max; i++) {
        let obj = data[i]
        labels[i] = { "label": obj[key] }
        dataSeriesImp[i] = { "value": obj.impressions }
        dataSeriesActive[i] = { "value": obj.apm || 0 }
    }
    return createStackedColumnDataSet(labels, dataSeriesImp, dataSeriesActive, caption, subcaption)
}


const addonDataSet = (data, caption, max = 5) => {
    let labels = []
    let dataSeriesImp = [], dataSeriesActive = []
    for (let i = 0; i < data.length && i < max; i++) {
        let obj = data[i]
        let metrics = (obj && obj.metrics) || false
        if (obj && obj.key) {
            labels[i] = { "label": obj.key }
        }
        if (metrics) {
            dataSeriesImp[i] = { "value": metrics.impressions }
            dataSeriesActive[i] = { "value": metrics.apm || 0 }
        }
    }
    return createStackedColumnDataSet(labels, dataSeriesImp, dataSeriesActive, caption)
}
export const getAddonDatas = (data, lumen = false, perMinute = true) => {
    let AddonData = {};
    //todo chart check
    if (lumen) {
        if (perMinute) {
            AddonData = {
                "publisher": addonDataSetLumen(data.publishers || false, "Publisher Breakdown", 10, true, "domain", perMinute),
                "deviceType": addonDataSetLumen(data.device_type || false, "Device Type", 5, true, "device_type", perMinute),
            }
        } else {
            AddonData = {
                "publisher": addonDataSetAmplified(data.publishers || false, "Publisher Breakdown", 10, "domain", "Top 10 publishers"),
                "daily": addonDataSetAmplified(data.daily || false, "Daily Breakdown", data?.daily?.length, "date", "For the selected time range"),
                "deviceType": addonDataSetAmplified(data.device_type || false, "Device Type", 5, "device_type"),
            }
        }
    }
    else {
        AddonData = {
            "publisher": addonDataSet(data.publisher || false, "Publisher Breakdown", 10),
            "deviceType": addonDataSet(data.deviceType || false, "Device Type"),
            "country": addonDataSet(data.country || false, "Country")
        }
    }
    return AddonData

}



export const sortLogic = (sort, originalData, caption = "", limit = 5, vertical = false, lumen = false, perMinute = true, subcaption = "", isEmissions = false) => {
    if (isEmissions) {
        // eslint-disable-next-line
        let sortBy = sort.property
        let data = originalData.sort((a, b) => {
            if (a && b) {
                if (sort.direction === "DESC") {
                    return b[sortBy] - a[sortBy];
                } else {
                    return a[sortBy] - b[sortBy];
                }
            }
        });
        return addonDataEmissions(data)
    } else if (lumen) {
        let key = originalData?.length && Object.keys(originalData[0])[0]
        // eslint-disable-next-line
        let data = originalData.sort((a, b) => {
            if (a && b) {
                let sortBy = sort.property
                if (sort.direction === "DESC") {
                    return b[sortBy] - a[sortBy];
                } else {
                    return a[sortBy] - b[sortBy];
                }
            }
        });
        if (perMinute) return addonDataSetLumen(data, caption, limit, vertical, key, perMinute)
        return addonDataSetAmplified(data, caption, limit, key, subcaption)
    }
    else if (originalData && originalData[0]?.metrics) {
        // eslint-disable-next-line
        let data = originalData.sort((a, b) => {
            if (a && b && a.metrics && b.metrics) {
                let sortBy = sort.property
                if (sort.direction === "DESC") {
                    return b.metrics[sortBy] - a.metrics[sortBy];
                } else {
                    return a.metrics[sortBy] - b.metrics[sortBy];
                }
            }
        });
        return addonDataSet(data, caption, limit, vertical)
    }


}

const createStackedColumnDataSet = (dataLabel, dataSeriesImp, dataSeriesActive, caption = "", subcaption = "") => {

    return {
        ...baseOption,
        grid: {
            left: "8%",
            right: "8%",
            top: 70,
            bottom: 40,
            containLabel: true,
        },
        legend: { top: "bottom", left: "center" },
        title: {
            text: caption || "Daily breakdown",
            subtext: subcaption || "For the selected time range",
            left: "center",
            top: 8,
            textStyle: { color: chartColour.dark, fontSize: 16 },
            subtextStyle: { color: chartColour.subtext, fontSize: 12 }
        },
        subtitle: subcaption || "For the selected time range",
        tooltip: { ...baseTooltip, trigger: "axis", axisPointer: { type: "cross" } },
        xAxis: [
            {
                type: "category",
                data: isEmpty(dataLabel) ? [] : dataLabel.map((item) => item.label),
                axisLabel: { rotate: caption === "Daily Breakdown" ? 90 : 0, color: chartColour.dark, interval: 0, formatter: (value) => caption === "Daily Breakdown" ? value : wrapLabel(value, 8) },
            },
        ],
        yAxis: [
            {
                type: "value",
                name: "Attention sec",
                position: "left",
                axisLabel: { color: chartColour.dark },
                splitLine: { lineStyle: { color: "#d9d9d9" } },
                nameGap: 25,
                nameLocation: "middle",
                nameRotate: 90,
                nameTextStyle: { color: "#a6a6a6" },
            },
            {
                type: "value",
                name: "Impressions",
                position: "right",
                axisLabel: { color: "#a6a6a6", formatter: function (value) { return shortFormNumber(value);  }},
                splitLine: { show:false },
                offset: 0,
                nameLocation: "middle",
                nameRotate: -90,
                nameGap: 35,
                nameTextStyle: { color: "#a6a6a6" },

            },
        ],
        series: [
            {
                name: "Attention Time",
                type: "bar",
                data: isEmpty(dataSeriesActive) ? [] : dataSeriesActive.map((item) => item.value),
                yAxisIndex: 0,
                itemStyle: { color: chartColour.main },
            },
            {
                name: "Impressions",
                type: "line",
                data: isEmpty(dataSeriesImp) ? [] : dataSeriesImp.map((item) => item.value),
                yAxisIndex: 1,
                smooth: true,
                lineStyle: { width: 2, color: "#1272a4" },
                itemStyle: { color: "#1272a4" },
                smooth: false,
                symbolSize: 6,
                //symbol: "circle",
                //itemStyle: { color: chartColour.highlight },
            },
        ],
    };
}
const createMyltiSeriesDataset = (dataLabel, dataSeriesImp, dataSeriesScore, caption = "", vertical = false, sYAxisName = "Attention Score") => {
    let isVertical = vertical ? { labelDisplay: "rotate", slantLabel: "1" } : {}

    return {
        ...baseOption,
        legend: { top: "bottom", left: "center" },
        title: caption || "Daily breakdown",
        tooltip: { ...baseTooltip, trigger: "axis", axisPointer: { type: "cross" } },
        xAxis: [
            {
                type: "category",
                data: isEmpty(dataLabel) ? [] : dataLabel.map((item) => item.label),
                axisLabel: { rotate: 45, color: chartColour.dark },
                axisLine: { lineStyle: { color: chartColour.neutral } },
            },
        ],
        yAxis: [
            {
                type: "value",
                name: sYAxisName || "Left Axis",
                position: "left",
                axisLabel: { color: chartColour.dark },
                splitLine: { lineStyle: { color: chartColour.neutral } },
            },
            {
                type: "value",
                name: "Impressions",
                position: "right",
                axisLabel: { color: chartColour.dark },
                splitLine: { lineStyle: { color: chartColour.neutral } },
            },
        ],
        series: [
            {
                name: sYAxisName,
                type: "bar",
                data: isEmpty(dataSeriesScore) ? [] : dataSeriesScore.map((item) => item.value),
                yAxisIndex: 0,
                itemStyle: { color: chartColour.main },
            },
            {
                name: 'Impression',
                type: "line",
                data: dataSeriesImp.map((item) => item.value),
                yAxisIndex: 1,
                smooth: true,
                itemStyle: { color: chartColour.highlight },
            },
        ],
    };
}
export const createAttentionScoreRM = (value, caption = "") => {

    return {
        ...baseOption,
        legend: { top: "bottom", left: "center" },
        title: { text: caption },
        series: [
            {
                type: "gauge",
                min: 0,
                max: 1000,
                progress: {
                    show: true,
                    width: 10,
                    itemStyle: {
                        color: "#A01A7D" // progress bar color
                    }
                },
                axisLine: {
                    lineStyle: {
                        width: 10,
                        color: [
                            [value / 1000, "#A01A7D"], // filled range
                            [1, "#F2F2F2"] // remaining
                        ]
                    }
                },
                pointer: {
                    show: true,
                    itemStyle: {
                        color: "#A01A7D"
                    }
                },
                axisTick: { show: false },
                splitLine: { show: false },
                axisLabel: { show: false },
                anchor: { show: false },
                detail: {
                    valueAnimation: true,
                    formatter: "{value}",
                    color: "#333"
                },
                data: [ { value: value } ]
            }
        ]
    };
}
export const amplifiedBenchmarkValue = 3

const calculateDecay = (imp, interval) => {
    return (Number(Number(interval) / Number(imp)) * 100).toFixed(2);

}
export const createAttentionScoreDecay = (summary, caption = "") => {
    //this is unused
    return (
        {
            "chart": {
                theme: "my-custom-theme",
                exportEnabled: "1",
                "numberSuffix": "%",
                chartBottomMargin: "5",
                caption: caption,
                yaxisname: "Impressions %",
                subcaption: "",
                showvalues: "0",
                legenditemfontsize: "15",
                legenditemfontbold: "1",
                plottooltext: "<b>$dataValue</b> Impressions on $label",
                paletteColors: "#a2137d",
                exportFormats: "png | jpg | svg | csv| xlsx",
                exportMode: "client",
                exportFileName: caption,
                borderColor: "#D9D9D9",
                labelFontColor: "#666666",
                borderRadius: "10",
                captionFontColor: "#202124",
                showBorder: "1",
                pivotRadius: '0',
                valueSuffix: "%",
            },
            categories: [
                {
                    category: [
                        {
                            label: "1s"
                        },
                        {
                            label: "2s"
                        },
                        {
                            label: "3s"
                        },
                        {
                            label: "4s"
                        },
                        {
                            label: "5s"
                        }
                    ]
                }
            ],
            dataset: [
                {
                    seriesname: "Active Attention",
                    data: [
                        {
                            value: calculateDecay(summary?.impressions, summary?.impressionsActive1s)
                        },
                        {
                            value: calculateDecay(summary?.impressions, summary?.impressionsActive2s)
                        },
                        {
                            value: calculateDecay(summary?.impressions, summary?.impressionsActive3s)
                        },
                        {
                            value: calculateDecay(summary?.impressions, summary?.impressionsActive4s)
                        },
                        {
                            value: calculateDecay(summary?.impressions, summary?.impressionsActive5s)
                        }
                    ]
                }
            ]
        }
    )
}
export const createAttentionScore = (summary, caption = "", value = amplifiedBenchmarkValue) => {
    return ({
        ...baseOption,
        legend: { top: "bottom", left: "center" },
        title: {
            text: caption,
            left: "center",
            top: 10,
            textStyle: { color: "#000", fontSize: 16 },
        },
        grid: { left: 40, right: 20, top: 80, bottom: 10, containLabel: true },
        series: [
            {
                type: "gauge",
                center: ['50%', '75%'],
                name: caption,
                min: 0,
                max: 10,
                splitNumber: 5,
                startAngle: 180,
                endAngle: 0,
                radius: '100%',
                axisLabel: {
                    distance: 4,
                    formatter: `{value}s`,
                },
                splitLine: {
                    distance: -10,
                    lineStyle: {
                        width: 1,
                    }
                },
                axisLine: {
                    lineStyle: {
                        width: 35,
                        color: [
                            [(summary.apm || 0) / 10, chartColour.main],
                            [1, chartColour.base],
                        ],
                    },
                },
                axisTick: { show: false},
                itemStyle: {
                color: "#f4c2d7"
                },
                pointer: {
                    icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                    length: '12%',
                    width: 15,
                    offsetCenter: [0, '-65%'],
                    //formatter: `{value} s`,
                    itemStyle: { color: chartColour.dark }
                },
                tooltip: {
                    show: true,
                    trigger: 'item',                          // override base
                    formatter: ({ value }) => `${(value)}s \nBenchmark\n(Total)`
                },
                detail: {
                    show: false,
                    /* valueAnimation: true,
                    fontSize: 16,
                    fontWeight: "bold",
                    color: chartColour.dark,
                    formatter: `{value} s`,
                    offsetCenter: [0, '-60%']  */
                },
                data: [
                    {
                        value: value,                        
                        name: ""
                    }],
            },
        ],
    });
}
export const renderAttentionScoreSummary = (attentionScoreSummary, loading, lumen) => {
    return (attentionScoreSummary && attentionScoreSummary.length ?
        lumen ?
            <ReportCard className="attention-score" hasSvg="/images/iq-transparent.svg" header="Attention Time (APM)" tipDescription="An overall evaluation of the attention metrics." objects={attentionScoreSummary || ""} loading={loading} />
            :
            <ReportCard className="attention-score" icon="fas fa-bullhorn bb-color_disabled_imp" header="Attention Time" tipDescription="An overall evaluation of the attention metrics in seconds per impression." objects={attentionScoreSummary || ""} loading={loading} /> : null)
}
export const renderAttentionSkeletons = (lumen) => <div className="mt-4 chart-container attention">
    <h3 className="bb-sub-header-txt mb-4">{lumen ? "Attention Score" : "Attention Time"}</h3>
    <Skeleton className=" m-2" width="514px" height="230px" />
</div>

export const renderHeader = (header, isOpen, toggle) => {
    return (
        <div className="d-flex flex-wrap col-12 justify-content-between mt-2 p-0 mb-3">
            <h5 className='text-dark font-weight-bold'>{header}</h5>
            <div className="accordion-arrow d-flex flex-row cursor-pointer" onClick={() => toggle()} >
                <span >{isOpen ? "Collapse" : "Expand"}  <i className={classnames("fas fa-caret-left", isOpen ? "rotate" : "")} aria-hidden="true"></i></span>
            </div>
        </div>
    )
}
export const getPrecentageBase = (value, base) => {
    if (value && base) {
        return ((value * 100) / base).toFixed(2)
    }
    else {
        return 0;
    }
}
export const renderVideoCards = (summary, loading, isInstream = false) => {
    return ((summary && summary.videoCompletionRate) || isInstream ? <div className='d-flex'>
        <div className='d-flex flex-column justify-content-between'>
            <ReportCard className="h-100" icon="fas fa-video" header="Video Start" objects={[{ label: "Total Video Starts", value: `${numberWithCommas(summary?.videoStart || 0)}` }] || ""} loading={loading} tipDescription="The measurement of users that started watching the video." />
            <ReportCard className="h-100" icon="fas fa-video" header="25% Quartile" objects={[{ label: "View Rate", value: `${getPrecentageBase(summary?.firstQuartile || 0, summary?.videoStart || 0)}%` }] || ""} loading={loading} tipDescription="The rate of users who watched 25% of the video against the total video starts." />
        </div>
        <div className='d-flex flex-column justify-content-between'>
            <ReportCard className="h-100" icon="fas fa-video" header="50% Quartile" objects={[{ label: "View Rate", value: `${getPrecentageBase(summary?.midpoint || 0, summary?.videoStart || 0)}%` }] || ""} loading={loading} tipDescription="The rate of users who watched 50% of the video against the total video starts." />
            <ReportCard className="h-100" icon="fas fa-video" header="75% Quartile" objects={[{ label: "View Rate", value: `${getPrecentageBase(summary?.thirdQuartile || 0, summary?.videoStart || 0)}%` }] || ""} loading={loading} tipDescription="The rate of users who watched 75% of the video against the total video starts." />
        </div>
        <ReportCard icon="fas fa-video" header="Video Completion" loading={loading} objects={[
            { label: "Completion Rate", value: `${summary?.videoCompletionRate || 0}%` },
            { label: "Total Completed Views", value: numberWithCommas(summary?.videoComplete || 0) }
        ] || ""} tipDescription={<>The measurement of users that watched the video to the end.<br />The rate is calculated against the total video starts.</>} />
    </div> : null)
}